import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  position = "top-right",
  ...props
}) => {
  return (
    <Sonner
      position={position}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-gray-900 border border-gray-200 shadow-lg rounded-lg",
          description: "text-gray-600",
          actionButton:
            "bg-[#548B2E] text-white hover:bg-[#3f6b20]",
          cancelButton:
            "bg-gray-100 text-gray-700 hover:bg-gray-200",
          success: "bg-green-50 border-green-200 text-green-800",
          error: "bg-red-50 border-red-200 text-red-800",
          warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
          info: "bg-[#EAF3F8] border-[#B3D4E5] text-[#2F6A8E]",
        },
      }}
      richColors
      closeButton
      {...props}
    />
  );
}

// Toast helper functions for easy usage
const showToast = {
  success: (message, options = {}) => toast.success(message, options),
  error: (message, options = {}) => toast.error(message, options),
  warning: (message, options = {}) => toast.warning(message, options),
  info: (message, options = {}) => toast.info(message, options),
  loading: (message, options = {}) => toast.loading(message, options),
  promise: (promise, messages) => toast.promise(promise, messages),
  dismiss: (id) => toast.dismiss(id),
};

export { Toaster, toast, showToast }
